export const businessInfo = {
  name: 'Miami Tours and Travel',
  phone: '+1-305-491-0131',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '2609 Collins Ave',
    addressLocality: 'Miami Beach',
    addressRegion: 'FL',
    postalCode: '33140',
    addressCountry: 'US',
  },
  sameAs: [
    'https://www.facebook.com/toursandtravel1/',
    'https://www.instagram.com/sunshine_intl_services/',
    'https://g.page/r/CXXpjbmPOif2EBM/review',
  ],
};
